var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{ref:"errorMessageModal",attrs:{"title":"Something went wrong","actionText":"Dismiss","contentClass":"error-message-window"}},[_c('ul',{staticClass:"error--text"},_vm._l((_vm.errors),function(error,field){return _c('li',{key:`error-message-${field}`},[_vm._v("\n            "+_vm._s(error)+"\n        ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }